<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Routing Group</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div id="accordion" class="container-fluid">
        <div class="d-none d-sm-inline-flex">
          <ul class="nav configuration-nav" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#bgp-router"
                role="tab"
                id="bgp-router-tab"
                ><i class="icon-refresh"></i> Routing BGP Router</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#network"
                role="tab"
                id="network-tab"
                ><i class="icon-lock"></i> Routing Network</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#peer-group"
                role="tab"
                id="peer-group-tab"
                ><i class="icon-lock"></i> Routing Peer Group</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#peering"
                role="tab"
                id="peering-tab"
                ><i class="icon-lock"></i> Routing Peering</a
              >
            </li>
          </ul>
        </div>

        <!-- Tab panes -->
        <div class="card">
          <div class="tab-content">
            <!-- <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div> -->

            <div class="pt-3 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded collapsed"
                data-toggle="collapse"
                data-target="#bgp-router"
                aria-expanded="true"
              >
                <i class="icon-refresh"></i> Roting BGP Router
              </h3>
            </div>
            <div class="tab-pane default active" id="bgp-router" data-parent="#accordion">
              <section class="content-header">
                <div class="container-fluid">
                  <div class="row mb-2">
                    <div class="col-sm-12">
                      <h1>
                        <router-link
                          :to="{ name: 'RoutingBGPRouterAdd' }"
                          class="btn ml-auto"
                          v-if="actionCreate && _.isEmpty(bgpRouterList.data)"
                        >
                          <i class="icon-plus"></i> New
                        </router-link>
                      </h1>
                    </div>
                    <!-- <div class="col-sm-6">
                      <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">
                          <router-link :to="{ name: 'Home' }">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active">Wifi Configuration</li>
                      </ol>
                    </div> -->
                  </div>
                </div>
                <!-- /.container-fluid -->
              </section>

              <section class="content" v-if="has_permission === true">
                <div class="container-fluid">
                  <div class="card">
                    <div
                      class="card-header py-3"
                      v-if="!_.isEmpty(bgpRouterList.data) && is_loading == false"
                    >
                      <div class="btn-toolbar pull-right">
                        <el-dropdown
                          split-button
                          :trigger="'click'"
                          @command="handleSelectedRows"
                          type="primary"
                          v-if="this.selected_bgp_router_row.length"
                          class="mr-1"
                        >
                          {{ this.selected_bgp_router_row.length }}
                          {{ "" | pluralize(this.selected_bgp_router_row.length) }}
                          selected
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ action: 'delete', tab: 'bgp' }"
                              >Delete</el-dropdown-item
                            >
                            <el-dropdown-item :command="{ action: 'enable', tab: 'bgp' }"
                              >Enable</el-dropdown-item
                            >
                            <el-dropdown-item :command="{ action: 'disable', tab: 'bgp' }"
                              >Disable</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <button
                          class="btn btn-info"
                          type="button"
                          @click="showFilter = !showFilter"
                        >
                          <i class="fa fa-filter"></i>
                          <span class="d-none d-sm-inline-flex">Filter</span>
                        </button> -->
                      </div>

                      <h3 class="card-title" v-if="organizationId == 1">
                        Total Item: {{ bgpRouterList.total }}
                      </h3>
                    </div>
                    <div class="overlay" v-if="is_loading">
                      <img src="/assets/images/loader.svg" alt="" />
                    </div>

                    <div class="card-body">
                      <div v-if="!_.isEmpty(bgpRouterList.data) && is_loading == false">
                        <div class="table-responsive-md">
                          <table class="table">
                            <thead>
                              <tr>
                                <!-- <th style="width: 24px">
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="is_selected_all_bgp"
                                      @click="selectedRowAll('bgp')"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </th> -->
                                <th>Status</th>
                                <th>Name</th>
                                <th>AS</th>
                                <th>Router ID</th>
                                <th class="text-right">Action</th>
                              </tr>
                            </thead>
                            <tbody class="list">
                              <tr v-for="(val, index) in bgpRouterList.data">
                                <!-- <td>
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="selected_bgp_router_row"
                                      :value="{
                                        id: val.id,
                                        accountId: val.accountId
                                      }"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </td> -->
                                <td>{{ val.status }}</td>
                                <td>{{ val.bgp_name }}</td>
                                <td>{{ val.bgp_as }}</td>
                                <td>{{ val.router_id }}</td>

                                <td class="text-right">
                                  <router-link
                                    v-if="actionEdit == true || checkEditPermission(val)"
                                    :to="{
                                      name: 'RoutingBGPRouterEdit',
                                      params: { id: val.id },
                                    }"
                                    class="btn btn-edit"
                                  >
                                    <i class="icon-edit"></i>
                                  </router-link>
                                  <a
                                    v-if="actionDelete == true"
                                    class="btn btn-trash"
                                    href="javascript:void(0)"
                                    @click="
                                      deleteObject(val.id, 'bgp', val.accountId, index)
                                    "
                                    ><i class="icon-trash"></i
                                  ></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        class="p-4"
                        v-if="_.isEmpty(bgpRouterList.data) && is_loading == false"
                      >
                        <div class="no-data">
                          <img src="/assets/images/no-data.svg" alt="" />
                          <h3>No data found!</h3>
                        </div>
                      </div>
                    </div>

                    <div
                      :class="{
                        'card-footer': bgpRouterList.total > bgpRouterList.per_page,
                      }"
                    >
                      <vue-pagination
                        :pagination="bgpRouterList"
                        v-if="bgpRouterList.total > bgpRouterList.per_page"
                        @paginate="reload()"
                      ></vue-pagination>
                    </div>
                  </div>
                </div>
              </section>

              <section class="content" v-if="has_permission === false">
                <div class="alert alert-danger alert-dismissible">
                  <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
                </div>
              </section>
            </div>

            <!-- routing network -->
            <div class="pt-3 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded collapsed"
                data-toggle="collapse"
                data-target="#network"
                aria-expanded="true"
              >
                <i class="icon-refresh"></i> Roting Network
              </h3>
            </div>
            <div class="tab-pane default" id="network" data-parent="#accordion">
              <section class="content-header">
                <div class="container-fluid">
                  <div class="row mb-2">
                    <div class="col-sm-12">
                      <h1>
                        <router-link
                          :to="{ name: 'RoutingNetworkAdd' }"
                          class="btn ml-auto"
                          v-if="actionCreate"
                        >
                          <i class="icon-plus"></i> New
                        </router-link>
                      </h1>
                    </div>
                  </div>
                </div>
                <!-- /.container-fluid -->
              </section>

              <section class="content" v-if="has_permission === true">
                <div class="container-fluid">
                  <div class="card">
                    <div
                      class="card-header py-3"
                      v-if="!_.isEmpty(networkList.data) && is_loading == false"
                    >
                      <div class="btn-toolbar pull-right">
                        <el-dropdown
                          split-button
                          :trigger="'click'"
                          @command="handleSelectedRows"
                          type="primary"
                          v-if="this.selected_network_row.length"
                          class="mr-1"
                        >
                          {{ this.selected_network_row.length }}
                          {{ "" | pluralize(this.selected_network_row.length) }}
                          selected
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              :command="{ action: 'delete', tab: 'network' }"
                              >Delete</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{ action: 'enable', tab: 'network' }"
                              >Enable</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{ action: 'disable', tab: 'network' }"
                              >Disable</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <button
                          class="btn btn-info"
                          type="button"
                          @click="showFilter = !showFilter"
                        >
                          <i class="fa fa-filter"></i>
                          <span class="d-none d-sm-inline-flex">Filter</span>
                        </button> -->
                      </div>
                      <h3 class="card-title" v-if="organizationId == 1">
                        Total Item: {{ networkList.total }}
                      </h3>
                    </div>
                    <div class="overlay" v-if="is_loading">
                      <img src="/assets/images/loader.svg" alt="" />
                    </div>

                    <div class="card-body">
                      <div v-if="!_.isEmpty(networkList.data) && is_loading == false">
                        <div class="table-responsive-md">
                          <table class="table">
                            <thead>
                              <tr>
                                <!-- <th style="width: 24px">
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="is_selected_all_network"
                                      @click="selectedRowAll('network')"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </th> -->

                                <th>Status</th>
                                <th>Name</th>
                                <th>Network</th>
                                <th class="text-right">Action</th>
                              </tr>
                            </thead>
                            <tbody class="list">
                              <tr v-for="(val, index) in networkList.data">
                                <!-- <td>
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="selected_network_row"
                                      :value="{
                                        id: val.id,
                                        accountId: val.accountId
                                      }"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </td> -->
                                <td>{{ val.status }}</td>
                                <td>{{ val.network_name }}</td>
                                <td>{{ val.network }}</td>

                                <td class="text-right">
                                  <router-link
                                    v-if="actionEdit == true || checkEditPermission(val)"
                                    :to="{
                                      name: 'RoutingNetworkEdit',
                                      params: { id: val.id },
                                    }"
                                    class="btn btn-edit"
                                  >
                                    <i class="icon-edit"></i>
                                  </router-link>
                                  <a
                                    v-if="actionDelete == true"
                                    class="btn btn-trash"
                                    href="javascript:void(0)"
                                    @click="
                                      deleteObject(
                                        val.id,
                                        'network',
                                        val.accountId,
                                        index
                                      )
                                    "
                                    ><i class="icon-trash"></i
                                  ></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        class="p-4"
                        v-if="_.isEmpty(networkList.data) && is_loading == false"
                      >
                        <div class="no-data">
                          <img src="/assets/images/no-data.svg" alt="" />
                          <h3>No data found!</h3>
                        </div>
                      </div>
                    </div>

                    <div
                      :class="{
                        'card-footer': networkList.total > networkList.per_page,
                      }"
                    >
                      <vue-pagination
                        :pagination="networkList"
                        v-if="networkList.total > networkList.per_page"
                        @paginate="reload()"
                      ></vue-pagination>
                    </div>
                  </div>
                </div>
              </section>

              <section class="content" v-if="has_permission === false">
                <div class="alert alert-danger alert-dismissible">
                  <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
                </div>
              </section>
            </div>

            <!-- routing Peer Group -->
            <div class="pt-3 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded collapsed"
                data-toggle="collapse"
                data-target="#peer-group"
                aria-expanded="true"
              >
                <i class="icon-refresh"></i> Roting Peer Group
              </h3>
            </div>
            <div class="tab-pane default" id="peer-group" data-parent="#accordion">
              <section class="content-header">
                <div class="container-fluid">
                  <div class="row mb-2">
                    <div class="col-sm-12">
                      <h1>
                        <router-link
                          :to="{ name: 'RoutingPeerGroupAdd' }"
                          class="btn ml-auto"
                          v-if="actionCreate"
                        >
                          <i class="icon-plus"></i> New
                        </router-link>
                      </h1>
                    </div>
                  </div>
                </div>
                <!-- /.container-fluid -->
              </section>

              <section class="content" v-if="has_permission === true">
                <div class="container-fluid">
                  <div class="card">
                    <div
                      class="card-header py-3"
                      v-if="!_.isEmpty(peerGroupList.data) && is_loading == false"
                    >
                      <div class="btn-toolbar pull-right">
                        <el-dropdown
                          split-button
                          :trigger="'click'"
                          @command="handleSelectedRows"
                          type="primary"
                          v-if="this.selected_peer_group_row.length"
                          class="mr-1"
                        >
                          {{ this.selected_peer_group_row.length }}
                          {{ "" | pluralize(this.selected_peer_group_row.length) }}
                          selected
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              :command="{ action: 'delete', tab: 'peerGroup' }"
                              >Delete</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{ action: 'enable', tab: 'peerGroup' }"
                              >Enable</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{ action: 'disable', tab: 'peerGroup' }"
                              >Disable</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <button
                          class="btn btn-info"
                          type="button"
                          @click="showFilter = !showFilter"
                        >
                          <i class="fa fa-filter"></i>
                          <span class="d-none d-sm-inline-flex">Filter</span>
                        </button> -->
                      </div>
                      <h3 class="card-title" v-if="organizationId == 1">
                        Total Item: {{ peerGroupList.total }}
                      </h3>
                    </div>
                    <div class="overlay" v-if="is_loading">
                      <img src="/assets/images/loader.svg" alt="" />
                    </div>

                    <div class="card-body">
                      <div v-if="!_.isEmpty(peerGroupList.data) && is_loading == false">
                        <div class="table-responsive-md">
                          <table class="table">
                            <thead>
                              <tr>
                                <!-- <th style="width: 24px">
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="is_selected_all_peer_group"
                                      @click="selectedRowAll('peerGroup')"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </th> -->
                                <th>Status</th>
                                <th>Name</th>
                                <th>Remote AS</th>
                                <th>Update Source</th>
                                <th>Route Map IN</th>
                                <th>Route Map Out</th>
                                <th>Hold Time</th>
                                <th>Force Next Hop Self</th>
                                <th class="text-right">Action</th>
                              </tr>
                            </thead>
                            <tbody class="list">
                              <tr v-for="(val, index) in peerGroupList.data">
                                <!-- <td>
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="selected_peer_group_row"
                                      :value="{
                                        id: val.id,
                                        accountId: val.accountId
                                      }"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </td> -->
                                <td>{{ val.status }}</td>
                                <td>{{ val.peer_group_name }}</td>
                                <td>{{ val.remote_as }}</td>
                                <td>{{ val.update_source }}</td>
                                <td>{{ val.route_map_in }}</td>
                                <td>{{ val.route_map_out }}</td>
                                <td>{{ val.hold_time }}</td>
                                <td>
                                  {{ val.force_nexthop_self == 1 ? "Yes" : "No" }}
                                </td>

                                <td class="text-right">
                                  <router-link
                                    v-if="actionEdit == true || checkEditPermission(val)"
                                    :to="{
                                      name: 'RoutingPeerGroupEdit',
                                      params: { id: val.id },
                                    }"
                                    class="btn btn-edit"
                                  >
                                    <i class="icon-edit"></i>
                                  </router-link>
                                  <a
                                    v-if="actionDelete == true"
                                    class="btn btn-trash"
                                    href="javascript:void(0)"
                                    @click="
                                      deleteObject(
                                        val.id,
                                        'peerGroup',
                                        val.accountId,
                                        index
                                      )
                                    "
                                    ><i class="icon-trash"></i
                                  ></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        class="p-4"
                        v-if="_.isEmpty(peerGroupList.data) && is_loading == false"
                      >
                        <div class="no-data">
                          <img src="/assets/images/no-data.svg" alt="" />
                          <h3>No data found!</h3>
                        </div>
                      </div>
                    </div>

                    <div
                      :class="{
                        'card-footer': peerGroupList.total > peerGroupList.per_page,
                      }"
                    >
                      <vue-pagination
                        :pagination="peerGroupList"
                        v-if="peerGroupList.total > peerGroupList.per_page"
                        @paginate="reload()"
                      ></vue-pagination>
                    </div>
                  </div>
                </div>
              </section>

              <section class="content" v-if="has_permission === false">
                <div class="alert alert-danger alert-dismissible">
                  <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
                </div>
              </section>
            </div>

            <!-- routing Peering -->
            <div class="pt-3 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded collapsed"
                data-toggle="collapse"
                data-target="#peer-group"
                aria-expanded="true"
              >
                <i class="icon-refresh"></i> Roting Peering
              </h3>
            </div>
            <div class="tab-pane default" id="peering" data-parent="#accordion">
              <section class="content-header">
                <div class="container-fluid">
                  <div class="row mb-2">
                    <div class="col-sm-12">
                      <h1>
                        <router-link
                          :to="{ name: 'RoutingPeeringAdd' }"
                          class="btn ml-auto"
                          v-if="actionCreate"
                        >
                          <i class="icon-plus"></i> New
                        </router-link>
                      </h1>
                    </div>
                  </div>
                </div>
                <!-- /.container-fluid -->
              </section>

              <section class="content" v-if="has_permission === true">
                <div class="container-fluid">
                  <div class="card">
                    <div
                      class="card-header py-3"
                      v-if="!_.isEmpty(peeringList.data) && is_loading == false"
                    >
                      <div class="btn-toolbar pull-right">
                        <el-dropdown
                          split-button
                          :trigger="'click'"
                          @command="handleSelectedRows"
                          type="primary"
                          v-if="this.selected_peering_row.length"
                          class="mr-1"
                        >
                          {{ this.selected_peering_row.length }}
                          {{ "" | pluralize(this.selected_peering_row.length) }}
                          selected
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              :command="{ action: 'delete', tab: 'peering' }"
                              >Delete</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{ action: 'enable', tab: 'peering' }"
                              >Enable</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{ action: 'disable', tab: 'peering' }"
                              >Disable</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <button
                          class="btn btn-info"
                          type="button"
                          @click="showFilter = !showFilter"
                        >
                          <i class="fa fa-filter"></i>
                          <span class="d-none d-sm-inline-flex">Filter</span>
                        </button> -->
                      </div>
                      <h3 class="card-title" v-if="organizationId == 1">
                        Total Item: {{ peeringList.total }}
                      </h3>
                    </div>
                    <div class="overlay" v-if="is_loading">
                      <img src="/assets/images/loader.svg" alt="" />
                    </div>

                    <div class="card-body">
                      <div v-if="!_.isEmpty(peeringList.data) && is_loading == false">
                        <div class="table-responsive-md">
                          <table class="table">
                            <thead>
                              <tr>
                                <!-- <th style="width: 24px">
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="is_selected_all_peering"
                                      @click="selectedRowAll('peering')"/>
                                    <span class="checkmark"></span
                                  ></label>
                                </th> -->
                                <th>Status</th>
                                <th>Name</th>
                                <th>ASN</th>
                                <th>Source IP</th>
                                <th>Peering IP</th>
                                <th>Peer Group</th>
                                <th>RM IN</th>
                                <th>RM Out</th>
                                <th>Hold Time</th>
                                <th>Next Hop Self</th>
                                <th class="text-right">Action</th>
                              </tr>
                            </thead>
                            <tbody class="list">
                              <tr v-for="(val, index) in peeringList.data">
                                <!-- <td>
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      v-model="selected_peering_row"
                                      :value="{
                                        id: val.id,
                                        accountId: val.accountId,
                                      }" />
                                    <span class="checkmark"></span
                                  ></label>
                                </td> -->
                                <td>{{ val.status }}</td>
                                <td>{{ val.name }}</td>
                                <td>{{ val.remote_as }}</td>
                                <td>{{ val.update_source_ip }}</td>
                                <td>{{ val.peering_ip }}</td>
                                <td>{{ val.peer_group ?? "No" }}</td>
                                <td>{{ val.route_map_in }}</td>
                                <td>{{ val.route_map_out }}</td>
                                <td>{{ val.hold_time }}</td>
                                <td>
                                  {{ val.force_nexthop_self == 1 ? "Yes" : "No" }}
                                </td>

                                <td class="text-right">
                                  <router-link
                                    v-if="actionEdit == true || checkEditPermission(val)"
                                    :to="{
                                      name: 'RoutingPeeringEdit',
                                      params: { id: val.id },
                                    }"
                                    class="btn btn-edit"
                                  >
                                    <i class="icon-edit"></i>
                                  </router-link>
                                  <a
                                    v-if="actionDelete == true"
                                    class="btn btn-trash"
                                    href="javascript:void(0)"
                                    @click="
                                      deleteObject(
                                        val.id,
                                        'peering',
                                        val.accountId,
                                        index
                                      )
                                    "
                                    ><i class="icon-trash"></i
                                  ></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        class="p-4"
                        v-if="_.isEmpty(peeringList.data) && is_loading == false"
                      >
                        <div class="no-data">
                          <img src="/assets/images/no-data.svg" alt="" />
                          <h3>No data found!</h3>
                        </div>
                      </div>
                    </div>

                    <div
                      :class="{
                        'card-footer': peeringList.total > peeringList.per_page,
                      }"
                    >
                      <vue-pagination
                        :pagination="peeringList"
                        v-if="peeringList.total > peeringList.per_page"
                        @paginate="reload()"
                      ></vue-pagination>
                    </div>
                  </div>
                </div>
              </section>

              <section class="content" v-if="has_permission === false">
                <div class="alert alert-danger alert-dismissible">
                  <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
const fileDownload = require("js-file-download");

export default {
  name: "RoutingPeering",
  metaInfo: {
    title: "Routing Peering | Dotlines",
  },
  components: {
    VuePagination,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    bgpRouterList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    networkList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    peerGroupList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    peeringList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: false,
    actionEdit: true,
    actionDelete: true,
    is_edit: true,
    bgp_api_url: "",
    network_api_url: "",
    peer_group_api_url: "",
    peering_api_url: "",
    showFilter: false,
    filter: {},
    value: {},
    pre: {},
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_bgp_router_row: [],
    selected_network_row: [],
    selected_peer_group_row: [],
    selected_peering_row: [],
    is_selected_all_bgp: false,
    is_selected_all_network: false,
    is_selected_all_peer_group: false,
    is_selected_all_peering: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }

    this.bgp_api_url = "/routing_bgp_routers";
    this.network_api_url = "/routing_networks";
    this.peer_group_api_url = "/routing_peer_groups";
    this.peering_api_url = "/routing_peerings";

    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/group_info"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      //   this.actionCreate = true;
      // }

      this.selectTab();

      await this.getBGPRouterList()
        .then((response) => {
          this.bgpRouterList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error);
        });
      await this.getNetworkList()
        .then((response) => {
          this.networkList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error);
        });
      await this.getPeerGroupList()
        .then((response) => {
          this.peerGroupList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error);
        });
      await this.getPeeringList()
        .then((response) => {
          this.peeringList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getBGPRouterList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.bgpRouterList.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.bgp_api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    getNetworkList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.networkList.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.network_api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    getPeerGroupList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.peerGroupList.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.peer_group_api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    getPeeringList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.peeringList.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.peering_api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },

    deleteObject: function (id, tab, accountId, index) {
      const _this = this;
      let delete_api_url = "";
      let list;

      if (tab == "bgp") {
        delete_api_url = this.bgp_api_url + "/" + id;
        list = this.bgpRouterList;
      } else if (tab == "network") {
        delete_api_url = this.network_api_url + "/" + id;
        list = this.networkList;
      } else if (tab == "peering") {
        delete_api_url = this.peering_api_url + "/" + id;
        list = this.peeringList;
      } else {
        delete_api_url = this.peer_group_api_url + "/" + id;
        list = this.peerGroupList;
      }

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                },
              })
              .then((response) => {
                list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((errors) => {
                _this.is_loading = false;
                if (errors.response.status === 501) {
                  this.$swal.fire(
                    "Failed!",
                    errors.response.data.errors.message,
                    "error"
                  );
                } else {
                  _this.$swal.fire("Failed!", "failed to delete.", "error");
                }
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },

    selectedRowAll: function (tab) {
      let list;
      let isSelectedAll;

      if (tab == "bgp") {
        isSelectedAll = this.is_selected_all_bgp = !this.is_selected_all_bgp;
        list = this.bgpRouterList;
      } else if (tab == "network") {
        isSelectedAll = this.is_selected_all_network = !this.is_selected_all_network;
        list = this.networkList;
      } else if (tab == "peering") {
        isSelectedAll = this.is_selected_all_peering = !this.is_selected_all_peering;
        list = this.peeringList;
      } else {
        isSelectedAll = this.is_selected_all_peer_group = !this
          .is_selected_all_peer_group;
        list = this.peerGroupList;
      }

      // const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        list.data.forEach(function (item) {
          items.push({ id: item.id, accountId: item.accountId });
        });

        if (tab == "bgp") {
          this.selected_bgp_router_row = items;
        } else if (tab == "network") {
          this.selected_network_row = items;
        } else if (tab == "peering") {
          this.selected_peering_row = items;
        } else {
          this.selected_peer_group_row = items;
        }
      } else {
        if (tab == "bgp") {
          this.selected_bgp_router_row = [];
        } else if (tab == "network") {
          this.selected_network_row = [];
        } else if (tab == "peering") {
          this.selected_peering_row = [];
        } else {
          this.selected_peer_group_row = [];
        }
      }
    },
    handleSelectedRows(command) {
      let type = 0;
      let notificationMessage;
      let notificationTitle;
      let url;
      let selectedRows;

      if (command.action === "delete") {
        notificationMessage = "Data deleted successfully";
        notificationTitle = "Deleted Successfully";
      } else {
        if (command.action === "enable") {
          type = 1;
        }
        notificationMessage = "Data Updated successfully";
        notificationTitle = "Updated Successfully";
      }

      //   if (this.selected_row.length > 1 && command === "enable") {
      //     this.$toaster.warning("Multiple enable is not allowed here");
      //     return;
      //   }
      if (command.tab == "bgp") {
        selectedRows = this.selected_bgp_router_row;
        url = this.bgp_api_url + "-bulk-action";
      } else if (command.tab == "network") {
        selectedRows = this.selected_network_row;
        url = this.network_api_url + "-bulk-action";
      } else if (command.tab == "peering") {
        selectedRows = this.selected_peering_row;
        url = this.peering_api_url + "-bulk-action";
      } else {
        selectedRows = this.selected_peer_group_row;
        url = this.peer_group_api_url + "-bulk-action";
      }

      axios({
        method: "POST",
        url: url,
        data: { ids: selectedRows, type: type, action: command.action },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          Notification.success({
            title: notificationTitle,
            message: notificationMessage,
            type: "success",
          });
          // this.initialize();
        })
        .catch((errors) => {
          if (!_.isEmpty(errors.response)) {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
            } else {
              this.$toaster.error(errors.response.data.message);
            }
          }
        })
        .finally(() => {
          this.is_selected_all_bgp = false;
          this.is_selected_all_network = false;
          this.is_selected_all_peer_group = false;
          this.is_selected_all_peering = false;
          this.selected_bgp_router_row = [];
          this.selected_network_row = [];
          this.selected_peer_group_row = [];
          this.selected_peering_row = [];
          this.initialize();
        });
    },

    selectTab() {
      if (!this.$route.params.tab) return;
      const allTabs = document.querySelectorAll(".nav-link");
      const allTabContents = document.querySelectorAll(".tab-pane");

      const tab = this.$route.params.tab;

      allTabs.forEach((tab) => tab.classList.remove("active"));
      allTabContents.forEach((content) => content.classList.remove("active"));

      // Add the active class to the desired tab and its corresponding content
      const targetTab = document.querySelector("#" + tab + "-tab");
      const targetContent = document.querySelector("#" + tab);

      if (targetTab && targetContent) {
        targetTab.classList.add("active");
        targetContent.classList.add("active");
      }
    },
  },

  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
